import { useTranslation } from "react-i18next";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router";
import { ROUTES_CONSTANTS } from "../../../constants";
import { ModuleLayout } from "../../../layouts";
import { ContentCard } from "../../../components";

const CompanyManagement = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ModuleLayout title={t("companyManagement.title")}>
      <ContentCard className="h-full flex flex-col items-center justify-center">
        <h2 className="mb-2 text-4xl font-medium text-black">
          {t("companyManagement.emptyTitle")}
        </h2>
        <p className="mb-6 max-w-xl text-center text-lg">
          {t("companyManagement.emptySubtitle")}
        </p>
        <button
          onClick={() => navigate(ROUTES_CONSTANTS.REGISTER_COMPANY)}
          className="flex flex-col items-center gap-2 border border-[#E3E3E3] rounded-lg px-12 py-16 cursor-pointer hover:bg-gray-50 transition"
        >
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50">
            <FiPlus className="h-8 w-8 text-primary-500" />
          </div>
          <span className="font-medium text-xl">
            {t("companyManagement.btnRegister")}
          </span>
        </button>
      </ContentCard>
    </ModuleLayout>
  );
};

export default CompanyManagement;
